import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { load, save } from 'redux-localstorage-simple'

import user from './features/user/userSlice'
import language from './features/language/languageSlice'
import { injectStore } from '../utils/api/service'

const rootReducer = combineReducers({
  user: user,
  language: language
})

const localStorageSettings = {
  states: ['user', 'language'],
  namespace: 'matching-lists-frontend',
  namespaceSeparator: '::',
}

const preloadedState = load(localStorageSettings)

const saveLocalStorageMiddleware = save(Object.assign({ debounce: 200, }, localStorageSettings))
const combinedMiddlewares = (getDefaultMiddleware) => getDefaultMiddleware().concat(saveLocalStorageMiddleware)

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware: combinedMiddlewares,
})

injectStore(store)

export default store
